<template>
    <section>
        <div>
            <ais-hits class="literature">
                <template #item="{ item }">
                    <figure class="resource">
                        <div>
                           <a :href="item.resourceUrl" v-on:click.stop.prevent="clicked(item.resourceUrl)"><img :src="icon(item)" :alt="item.title"></a>
                            <a class="button simple alternate" :href="item.resourceUrl" v-on:click.stop.prevent="clicked(item.resourceUrl)">View</a>
                        </div>

                        <figcaption>
                            <span class="category-display" v-text="item.categoryDisplay"></span>
                            <h2><a :href="item.resourceUrl" v-text="item.title" v-on:click.stop.prevent="clicked(item.resourceUrl)"></a></h2>
                            <span class="subhead" v-text="item.subHead"></span>
                        </figcaption>

                    </figure>
                </template>
            </ais-hits>

            <ais-stats v-slot="{ nbHits, query }">
                <ais-pagination v-if="nbHits" />
                <div class="container" v-else>
                    <h1>
                        There are no results for {{ query }}.
                    </h1>
                    <p>
                        Do you need further assistance? You can <a href="/company/contact-us">contact us</a> with any questions you have.
                    </p>
                </div>
            </ais-stats>
        </div>
        <!--<loading v-else></loading>-->
    </section>
</template>

<script>
import { SearchClient, SearchRouting } from 'vue/AlgoliaSearch'
import moment from 'moment';

export default {
    props: [
        'index',
        'query',
    ],

    data: () => ({
        SearchClient,
        SearchRouting,
    }),

    filters: {
        momentDate: function (date) {
            return moment.utc(date).local().format('MMMM D, YYYY');
        },
    },

    methods: {
        clicked(url) {
            let external = (
                !url.match(new RegExp(window.location.pathname))
            );

            let empty = url == '';
            let js = url.match(/javascript/i);
            let file = url.match(/(\.pdf|\.dwg)/i);

            if (!empty && !js) {
                if ((external || file)) {
                    window.open(url);
                } else {
                    window.location.assign(url);
                }
            }
        },
        icon(result) {
            if (result.resourceImage) {
                // We may need to resolve sizing/aspect ratio issues before we can use resourceImage
                return result.resourceImage;
            }
            return (result.videos) ? '/img/icons/icon_resource-video.svg' : '/img/icons/icon_resource-pdf.svg';
        },
    },

    mounted() {
        let $state = $('.state');

        let resourceCategory = $state.data('resource');
        let resourceType = $state.data('type');

        if(resourceCategory && resourceType){

            if(resourceType == "all"){
                this.$emit('select-all', resourceCategory);
                return;
            }

            this.$emit('update-refinement', resourceCategory, resourceType);
            return;
        }
    }
}
</script>
